













import Vue from 'vue'
import { Transfer } from 'element-ui'
import { sortBy } from 'lodash'
import './ManageCasters.scss'
import { UserProfile } from '@/types/users'
import '@/styles/components/transfer.scss'

interface CasterColumn {
  key: string,
  label: string
}

export default Vue.extend({
  name: 'ManageCasters',
  props: {
    team: {
      type: Array as () => UserProfile[]
    },
    casters: {
      type: Object as () => any
    }
  },
  created () {
    this.formatCasters()
  },
  computed: {
    formattedTeam () : CasterColumn[]{
      let newArray: CasterColumn[]= []
      for (const p of this.team) {
        if (p.anonymous) continue
        const col = {
          key: p.user_id,
          label: p.first_name + ' ' + p.last_name
        } as CasterColumn
        newArray.push(col)
      }
      newArray = sortBy(newArray, [caster => caster.label.toLowerCase()])
      return newArray
    }
  },
  data () {
    return {
      localCasters: [] as string[]
    }
  },
  methods: {
    listChanged () {
      this.$emit('castersChanged', this.localCasters)
    },
    formatCasters () {
      for (const key in this.casters) {
        if (this.casters[key].anonymous) continue
        this.localCasters.push(key)
      }
    }
  },
  components: {
    'el-transfer': Transfer
  }
})
